import script from "./PricingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingPanel.vue?vue&type=script&setup=true&lang=js"

import "./PricingPanel.vue?vue&type=style&index=0&id=5ce42cda&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce42cda"]])

export default __exports__